<template>
  <div class="tradingProductRewards">
    <div class="trade_list">
      <ul>
        <li @click="tabChange(index)" v-for="(item,index) in tradeData" :class="{'checked':tradeIndex==index}">
          {{item.name}}
        </li>
      </ul>
      <el-button type="primary" size="medium">{{$t('common.edit')}}</el-button>
    </div>
    <div class="proportion">
      <span>交易奖励分成比例</span>
      <el-input v-model="proportion" type="number"></el-input>
      <span>%</span>
    </div>
    <div class="product_list">
      <ul>
        <li v-for="item in productData">
          <span>{{item.name}}</span>
          <el-input v-model="item.value" type="number"></el-input>
        </li>
      </ul>
    </div>
    <div>
      <el-button type="primary" size="medium">{{$t('common.cancle')}}</el-button>
      <el-button type="primary" size="medium">{{$t('common.ok')}}</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tradingProductRewards',
    data() {
      return {
        tradeData: [
          { name: 'FX', id: 0 },
          { name: 'METAL', id: 1 },
          { name: 'INDEX', id: 2 },
          { name: 'ENERGY', id: 3 }
        ],
        tradeIndex: 0,
        proportion: '',
        productData: [
          { name: 'AUDJPY-FX', value: 1 },
          { name: 'AUDJPY-FX', value: 1 },
          { name: 'AUDJPY-FX', value: 1 },
          { name: 'AUDJPY-FX', value: 1 }
        ]
      }
    },
    methods: {
      tabChange(index) {
        this.tradeIndex = index
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tradingProductRewards {
    margin: 20px;

    .trade_list {
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 60%;

      ul {
        display: flex;
        justify-content: flex-start;
        border-left: solid 1px #eee;
        margin-right: 60px;

        li {
          font-size: 16px;
          border-right: solid 1px #eee;
          border-top: solid 1px #eee;
          border-bottom: solid 1px #eee;
          padding: 8px 15px;
          width: 100px;
          text-align: center;
          cursor: pointer;

          &.checked {
            color: #fff;
            background: #409eff;
          }
        }

      }
    }

    .proportion {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 20px 0;

      span {
        font-size: 16px;
      }

      .el-input {
        width: 160px;
        border: solid 1px #eee;
        font-size: 16px;
        height: 36px;
        line-height: 36px;
        margin: 0 10px;
      }
    }

    .product_list {
      ul {
        overflow-y: scroll;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        max-height: 800px;

        li {
          width: 25%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-bottom: 20px;

          span {
            font-size: 16px;
          }

          .el-input {
            width: 100px;
            font-size: 16px;
            height: 36px;
            line-height: 36px;
            margin: 0 10px;
          }
        }

      }
    }

  }
</style>
